<ng-container *ngIf="!(publicationAccessService.hasPendingRequest$|async) && userService.user$|async as user">
  <div *ngIf="(extProfilesService.extProfilesToAskIndex$|async)" class="content p-4">

    <div class="text-md font-semibold text-primary">{{user.id}} / {{user.name}} / {{user.sourceIp}}</div>

    <!-- Ext que le user a déjà   -->
    <pre class="hljs p-4">{{user.extProfiles|json}}</pre>

    <!-- Désactivation temporaire car fonctionne mal   -->
    <ng-container *ngIf="true">
      <div class="mt-4 mb-2 text-xl font-semibold text-primary">Ext manager</div>
      <div class="flex flex-col rounded-lg bg-gray-200 p-8">
        <div class="flex flex-row items-center">
          <mat-form-field class="w-full" appearance="outline">
            <mat-label>Group profiles name</mat-label>
            <input matInput type="text" [formControl]="fDebug.get('saveLabel')">
          </mat-form-field>
          <button mat-raised-button (click)="saveExt(user)" class="ml-2">
            <mat-icon [svgIcon]="'heroicons_solid:save'"></mat-icon>
            <span class="ml-1">Save Ext</span>
          </button>
        </div>

        <div class="flex flex-row items-center">
          <mat-form-field appearance="outline" class="w-full">
            <mat-label>Profil block to load</mat-label>
            <mat-select [formControl]="fDebug.get('loadLabel')">
              <mat-option *ngFor="let key of getSavedListKey()" [value]="key">
                {{key}}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <button mat-raised-button class="ml-2" (click)="loadExt()">
            <span class="ml-1">Load Ext</span>
          </button>
          <!--            <button mat-button class="ml-2" (click)="nextAllExt()">-->
          <!--                <span class="ml-1">Next all</span>-->
          <!--            </button>-->
        </div>
        <div class="flex flex-row">
          <button mat-button class="ml-2" (click)="clearStore()">
            <mat-icon>delete_forever</mat-icon>
            <span class="ml-1">Clear Store</span>
          </button>
          <span class="w-full"></span>
          <button mat-button class="ml-2" (click)="clearExt()">
            <mat-icon>delete</mat-icon>
            <span class="ml-1">Clear Ext</span>
          </button>
        </div>
      </div>
    </ng-container>

    <!-- Ext que le user a déjà   -->
    <div class="mt-4 mb-2 text-xl font-semibold text-primary">{{'Answered'|transloco}}</div>
    <ng-container *ngFor="let anExt of getAnsweredUserExtProfileKeys(user)">

      <div class="mt-4 py-4 px-5 rounded-lg bg-gray-200 dark:bg-gray-800 ng-star-inserted">
        <div class="font-bold">{{anExt}} : {{user.extProfiles[anExt]}}</div>
        <ng-container *ngIf="extProfilesService.extDef[anExt]">
          <div class="flex flex-auto flex-col w-full mt-2">
            <ng-container [appExt]="extProfilesService.extDef[anExt]"></ng-container>
          </div>
        </ng-container>
      </div>

    </ng-container>

    <hr class="my-8">

    <!-- Ext que le user a aller chercker   -->
    <div class="mt-4 mb-2 text-xl font-semibold text-warn">{{'Unanswered'|transloco}}</div>
    <ng-container *ngFor="let anExt of getUnansweredUserExtProfileKeys(user)">
      <div class="mt-4 py-4 px-5 rounded-lg bg-gray-200 dark:bg-gray-800 ng-star-inserted">
        <div class="font-bold">{{anExt}}</div>
        <div class="flex flex-auto flex-col w-full" *ngIf="extProfilesService.extHasParams(anExt)">
          <ng-container [appExt]="extProfilesService.extDef[anExt]"></ng-container>
        </div>
      </div>
    </ng-container>
  </div>
</ng-container>
